export default __webpack_public_path__ + "static/media/product-image-hover-16.9917d016.jpg";